import React from 'react';
import {Icon} from "types/Icon";
import Link from "../Link";

type Props = {
    icon: Icon
    value: string | number
    url?: string
}

function PageMetaItem({icon, value, url}: Props) {
    const Icon = icon

    return (
        <div className="mt-2 flex items-center text-sm text-gray-500">
            <Icon className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />

            {!!url && (
              <Link to={url}>{value}</Link>
            )}

            {!url && (
              <span>{value}</span>
            )}
        </div>
    );
}

export default PageMetaItem;